import MDBox from "components/MDBox";
import DefaultSortInfoCard from "examples/Cards/InfoCards/DefaultInfoCard/DefaultSortInfoCard";
import React from "react";
import { useMaterialUIController } from "context";
import Grid from "@mui/material/Grid";

const Statistics = ({ data }) => {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  return (
    <>
      <MDBox>
        <Grid container alignItems="center" spacing={2}>
          <Grid item md={3} xs={12}>
            <DefaultSortInfoCard
              color={sidenavColor}
              icon="book_online"
              title="Total Renewals"
              value={`${data.totalRenewals}`}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultSortInfoCard
              color={sidenavColor}
              icon="real_estate_agent"
              title="Total Renewed"
              value={`${data.totalRenewed}`}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultSortInfoCard
              color={sidenavColor}
              icon="settings_account_box"
              title="Canceled"
              value={`${data.totalCanceled}`}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultSortInfoCard
              color={sidenavColor}
              icon="book_online"
              title="Failed"
              value={`${data.totalFailed}`}
            />
          </Grid>
        </Grid>
      </MDBox>
    </>
  );
};

export default Statistics;
